export default "__VITE_ASSET__BR_ZUJJ0__"